import { useUiFramework } from '../../providers/UiFrameworkProvider'

import { RecurrenceCalendar as LegacyRecurrenceCalendar } from './legacy/RecurrenceCalendar'
import { RecurrenceCalendar as TidalRecurrenceCalendar } from './tidal/RecurrenceCalendar'

type Props = {
  inEditMode: boolean
}

export function RecurrenceCalendar(props: Props) {
  const { inEditMode } = props
  const uiFramework = useUiFramework()

  switch (uiFramework) {
    case 'legacy':
      return <LegacyRecurrenceCalendar inEditMode={inEditMode} />

    case 'tidal':
      return <TidalRecurrenceCalendar inEditMode={inEditMode} />
  }
}
